module.exports = __webpack_public_path__ + "static/media/beyondly_brand_banner.1b4e2f44.jpg";